// document.addEventListener( 'DOMContentLoaded', function () {
//   if(document.querySelectorAll('.section-nf-category-slider')) {
//     document.querySelectorAll('.section-nf-category-slider').forEach( slideWrapper => {
//       let paginationClass = slideWrapper.querySelector('.splide__pagination')?.dataset.class
//       let sldeContainerId = slideWrapper.querySelector('.splide')?.getAttribute('id')
//       let sldeContainer = slideWrapper.querySelector('.splide')
//       let enableDesktopSlider = sldeContainer.dataset.enableDesktopSlider === "true" ? false : true;
//       let enableMobileSlider  = sldeContainer.dataset.enableMobileSlider === "true" ? false : true;
//       let desktopPerPage = parseInt(sldeContainer.dataset.desktopPerPage);
//       let mobilePerPage = parseInt(sldeContainer.dataset.mobilePerPage);
//       let desktopColumnGap = parseInt(sldeContainer.dataset.desktopColumnGap);
//       let mobileColumnGap = parseInt(sldeContainer.dataset.mobileColumnGap);
//       let settingData = {
//         type: 'slide',
//         gap: desktopColumnGap,
//         perPage: desktopPerPage,
//         destroy: enableDesktopSlider,
//         perMove: 1,
//         updateOnMove: false,
//         pagination: true,
//         breakpoints: {
//           749: {
//             classes: {
//               arrows: 'splide__arrows',
//               prev  : 'splide__arrow--prev splide__arrow--prev',
//               next  : 'splide__arrow--next splide__arrow--next'
//             },
//             type: "loop",
//             focus: "start",
//             arrows: false,
//             pagination: true,
//             perPage: 2,
//             perMove: 1,
//             destroy: enableMobileSlider,
//             gap: mobileColumnGap,
//             drag   : 'free',
//             snap   : true,
//           }
//         }
//       }
//       settingData.type = 'slide'
//       let nfCategorySlider = new Splide(`#${sldeContainerId}`, settingData).mount();
//     })
//   }
// });

document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.section-nf-category-slider');
  if (!sliders.length) return;

  requestAnimationFrame(() => {
    sliders.forEach(slideWrapper => {
      let sldeContainer = slideWrapper.querySelector('.splide');
      let sldeContainerId = sldeContainer?.getAttribute('id');

      let enableDesktopSlider = sldeContainer.dataset.enableDesktopSlider !== "true";
      let enableMobileSlider  = sldeContainer.dataset.enableMobileSlider !== "true";

      let settingData = {
        type: 'slide',
        gap: parseInt(sldeContainer.dataset.desktopColumnGap),
        perPage: parseInt(sldeContainer.dataset.desktopPerPage),
        destroy: enableDesktopSlider,
        perMove: 1,
        pagination: true,
        breakpoints: {
          749: {
            type: "loop",
            arrows: false,
            pagination: true,
            perPage: parseInt(sldeContainer.dataset.mobilePerPage) || 2,
            destroy: enableMobileSlider,
            gap: parseInt(sldeContainer.dataset.mobileColumnGap),
            drag: 'free',
            snap: true,
          }
        }
      };

      new Splide(`#${sldeContainerId}`, settingData).mount();
    });
  });
});
